import { useState, useEffect } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { Form, Button, Alert, Container, Card, Spinner } from "react-bootstrap";
import { login, isAuthenticated, getLockoutRemainingMs } from "./adminAuth";

const formatLockout = (ms) => {
  const mins = Math.ceil(ms / 60000);
  return `${mins} min`;
};

const AdminLogin = () => {
  const history = useHistory();
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [alreadyAuthed, setAlreadyAuthed] = useState(false);

  useEffect(() => {
    isAuthenticated().then((ok) => {
      setAlreadyAuthed(ok);
      setChecking(false);
    });
  }, []);

  if (checking) {
    return (
      <div className="admin-page admin-login">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (alreadyAuthed) {
    return <Redirect to="/admin" />;
  }

  const lockoutMs = getLockoutRemainingMs();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const result = await login(user.trim(), password);
    setLoading(false);

    if (result.ok) {
      history.push("/admin");
      return;
    }

    if (result.locked) {
      setError(`Demasiados intentos. Probá de nuevo en ${formatLockout(result.remainingMs)}.`);
      return;
    }

    if (result.attemptsLeft !== undefined) {
      setError(`Usuario o contraseña incorrectos. Te quedan ${result.attemptsLeft} intentos.`);
      return;
    }

    setError("Usuario o contraseña incorrectos.");
  };

  return (
    <div className="admin-page admin-login">
      <Container style={{ maxWidth: 420 }}>
        <Card className="admin-card shadow-sm">
          <Card.Body className="p-4">
            <h1 className="admin-login__title h4 mb-1">Panel de administración</h1>
            <p className="text-muted small mb-4">Acceso restringido</p>

            {lockoutMs > 0 && (
              <Alert variant="warning">
                Acceso bloqueado temporalmente. Reintentá en {formatLockout(lockoutMs)}.
              </Alert>
            )}

            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="adminUser">
                <Form.Label>Usuario</Form.Label>
                <Form.Control
                  type="text"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                  autoComplete="username"
                  required
                  disabled={loading || lockoutMs > 0}
                />
              </Form.Group>

              <Form.Group className="mb-4" controlId="adminPassword">
                <Form.Label>Contraseña</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                  disabled={loading || lockoutMs > 0}
                />
              </Form.Group>

              <Button type="submit" variant="dark" className="w-100" disabled={loading || lockoutMs > 0}>
                {loading ? "Verificando…" : "Ingresar"}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default AdminLogin;
